import { useEffect, useMemo, useState } from "react";
import useApi from "./apiService";

export default function useFilteredAttributes({
  resourceId,
  attributes: externalAttributes,
  disableLocking = false,
  enabled = true,
}) {
  const { fetchData } = useApi();
  const [attributes, setAttributes] = useState([]);
  const [featureMap, setFeatureMap] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !resourceId) return;

    const fetchAttributes = async () => {
      try {
        setLoading(true);
        const res = await fetchData(`/attributes/resources/${resourceId}`);
        setAttributes(res.data || []);
      } catch (err) {
        console.error(err);
        setAttributes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAttributes();
  }, [resourceId, enabled]);

  useEffect(() => {
    if (!enabled || disableLocking) return;

    const fetchFeatures = async () => {
      try {
        const res = await fetchData("/feature-attributes");
        const map = {};

        res.data.forEach((item) => {
          const id = item.attribute.id;
          if (!map[id]) map[id] = false;
          if (item.feature?.is_enabled) map[id] = true;
        });

        setFeatureMap(map);
      } catch (err) {
        console.error(err);
      }
    };

    fetchFeatures();
  }, [enabled, disableLocking]);

  const sourceAttributes = externalAttributes ?? attributes;

  const filteredAttributes = useMemo(() => {
    let data = [...sourceAttributes];

    if (!disableLocking) {
      data = data.filter((attr) => !attr.slug?.startsWith("adm_"));

      data = data.filter((attr) => {
        if (!(attr.id in featureMap)) return true;
        return featureMap[attr.id] === true;
      });
    }

    return data;
  }, [sourceAttributes, featureMap, disableLocking]);

  return { attributes: filteredAttributes, loading };
}
